// src/features/AppFooter/AppFooter.js
import React from "react";
import { Bar } from "@cadenza/ui";

// Custom hook to handle external links
/* function useExternalLink(url) {
  return () => window.open(url, "_blank", "noopener,noreferrer");
}
 */
function AppFooter() {
  const rightContent = null;
  const centreContent = (
    <>
      <img src="/SunIcon.png" alt="Company Logo" className="bar-text-image" />
      <div className="centre-text">Composed Software Ltd.</div>
      <img src="/MoonIcon.png" alt="Company Logo" className="bar-text-image" />
    </>
  );

  const leftContent = null;

  return (
    <div className="footer">
      <Bar
        leftContent={leftContent}
        centreContent={centreContent}
        rightContent={rightContent}
      />
    </div>
  );
}

export default AppFooter;
